import PropTypes from 'prop-types';

import chevronIcon from '@shared/assets/images/chevron_rignt_mobile.svg';

import styles from './MobileModalHeader.module.scss';

/**
 * 모바일 헤더 컴포넌트
 * - 피그마 디자인: 왼쪽 뒤로가기(<) 버튼 + 가운데 제목
 * - 모바일 페이지/모달의 상단 헤더로 사용
 */
function MobileModalHeader({ title, onBack }) {
  return (
    <header className={styles.header}>
      <button type="button" className={styles.backButton} onClick={onBack} aria-label="뒤로가기">
        <img src={chevronIcon} alt="뒤로가기" width={24} height={24} />
      </button>
      <h1 className={styles.title}>{title}</h1>
      {/* 오른쪽 여백 맞추기용 빈 영역 */}
      <div className={styles.spacer} />
    </header>
  );
}

MobileModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default MobileModalHeader;
